import React from "react";
import { Link } from "react-router-dom";

/**
 * Компактная строка-подсказка вместо тихого return null у виджетов.
 * Принцип «фича видна пустой»: блок без данных честно говорит, что здесь
 * будет и куда нажать, вместо исчезновения. Для полностраничных пустых
 * состояний — components/EmptyState.tsx (другой компонент, не дублировать).
 */
export function FeatureTeaser({
  icon,
  title,
  hint,
  cta,
  to,
  onClick,
  testId,
}: {
  icon?: React.ReactNode;
  title: string;
  hint?: string;
  /** короткий текст действия справа (без него — просто информ-строка) */
  cta?: string;
  to?: string;
  onClick?: () => void;
  testId?: string;
}) {
  const inner = (
    <div className="flex items-center gap-2.5 px-3.5 py-2.5">
      {icon && <span className="text-fg-muted shrink-0">{icon}</span>}
      <div className="min-w-0 flex-1">
        <div className="text-xs font-medium text-fg-secondary truncate">
          {title}
        </div>
        {hint && (
          <div className="text-[11px] text-fg-muted truncate">{hint}</div>
        )}
      </div>
      {cta && (
        <span className="text-[11px] text-accent font-medium shrink-0">
          {cta} →
        </span>
      )}
    </div>
  );

  if (to) {
    return (
      <Link
        to={to}
        data-testid={testId}
        className="block indigo-card hover:bg-bg-raised/40 transition-colors"
      >
        {inner}
      </Link>
    );
  }
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className="block w-full text-left indigo-card hover:bg-bg-raised/40 transition-colors"
      >
        {inner}
      </button>
    );
  }
  return (
    <div data-testid={testId} className="indigo-card">
      {inner}
    </div>
  );
}
